import Constants from './Constants';

export const getSessionAccessToken = () => sessionStorage.getItem(Constants.STORAGE_ACCESS_TOKEN_KEY);

export const setSessionAccessToken = (token) => sessionStorage.setItem(Constants.STORAGE_ACCESS_TOKEN_KEY, token);

export const removeSessionAccessToken = () => sessionStorage.removeItem(Constants.STORAGE_ACCESS_TOKEN_KEY);

export const setCachedFavicon = (favicon) => localStorage.setItem(Constants.STORAGE_FAVICON_KEY, favicon);

export const getCachedFavicon = () => localStorage.getItem(Constants.STORAGE_FAVICON_KEY);

export const setCachedLogo = (logo) => localStorage.setItem(Constants.STORAGE_LOGO_KEY, logo);

export const getCachedLogo = () => localStorage.getItem(Constants.STORAGE_LOGO_KEY);
